// Configuração por canal do Upload de Arquivos (PO1-2717).
//
// A tela é uma só (`UploadArquivosCanal`); o que muda entre o lado do
// embarcador e o do transportador é o que está aqui: textos, endpoints, se
// exige transportadora selecionada e os ids de DOM.

export const CANAL_EMBARCADOR = "embarcador";
export const CANAL_TRANSPORTADOR = "transportador";
// PO1-2310: a MESMA tela no MeuFrete, para o usuário de transportadora enviar
// pelo próprio canal. A transportadora é a do login (fixa); só escolhe o
// embarcador no topo.
export const CANAL_MEUFRETE = "meufrete";

export const CANAIS = {
  [CANAL_EMBARCADOR]: {
    canal: CANAL_EMBARCADOR,
    eyebrow: "Sustentação",
    titulo: "Upload de arquivos embarcador",
    descricao:
      'Envie os arquivos do embarcador diretamente para a fila de processamento. O processamento é assíncrono, então acompanhe o desfecho no card "Últimos envios".',
    urlTipos: (empresaId) => `/UploadArquivo/TipoInformacaoEmbarcador/${empresaId}`,
    urlPost: "/UploadArquivo/ArquivoEmbarcador",
    exigeTransportadora: false,
    inputId: "upload-embarcador-input",
    checkboxId: "upload-embarcador-notificar",
    mensagemGate: "Selecione um embarcador específico para usar esta tela.",
  },
  [CANAL_TRANSPORTADOR]: {
    canal: CANAL_TRANSPORTADOR,
    eyebrow: "Sustentação",
    titulo: "Upload de arquivos transportador",
    descricao:
      'Envie os arquivos da transportadora diretamente para a fila de processamento. O processamento é assíncrono, então acompanhe o desfecho no card "Últimos envios".',
    urlTipos: (empresaId, transportadoraId) =>
      `/UploadArquivo/TipoInformacao/${empresaId}/${transportadoraId}`,
    urlPost: "/UploadArquivo/ArquivoTransportador",
    exigeTransportadora: true,
    inputId: "upload-transportador-input",
    checkboxId: "upload-transportador-notificar",
    mensagemGate:
      "Selecione um embarcador e uma transportadora específicos para usar esta tela.",
  },
  [CANAL_MEUFRETE]: {
    canal: CANAL_TRANSPORTADOR,
    eyebrow: "MeuFrete",
    titulo: "Envio de arquivos",
    descricao:
      'Envie CT-e, fatura ou ocorrência para o embarcador escolhido no topo da página. O arquivo entra na mesma fila da integração; acompanhe o desfecho no card "Últimos envios".',
    urlTipos: (empresaId, transportadoraId) =>
      `/UploadArquivo/TipoInformacao/${empresaId}/${transportadoraId}`,
    urlPost: "/UploadArquivo/ArquivoTransportador",
    exigeTransportadora: false,
    transportadoraFixa: true,
    inputId: "upload-meufrete-input",
    checkboxId: "upload-meufrete-notificar",
    mensagemGate: "Escolha o embarcador no topo da página.",
  },
};

export const URL_ULTIMOS_ENVIOS = "/UploadArquivo/UltimosEnvios";
